export default __webpack_public_path__ + "static/media/Formular.254f9c82.woff";